<template>
  <layout-content>
    <section class="d-flex">
      <div class="b-tabs w-20">
        <tabs type="card" :animated="false" :value="current_tab" @on-click="set_tab">
          <template v-for="tab in tabs">
            <tab-pane v-if="Object.keys(user.rates).includes(tab)" :key="tab" :name="tab" :label="get_name_tab(tab)" />
          </template>
        </tabs>
      </div>

      <div class="b-tabs-contet w-100">
        <filter-component :type="current_tab" />
        <table-component />
      </div>
    </section>
  </layout-content>
</template>

<script>
  import { PriceType } from '@core/models/price-type';
  import TableComponent from '@core/components/prices/prices-table';
  import FilterComponent from '@core/components/prices/prices-table-filter';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      TableComponent,
      FilterComponent
    },

    computed: {
      ...mapGetters('core/auth', ['user']),

      tabs: function() {
        return PriceType.getList();
      },

      current_tab: function() {
        return this.$route.params.type;
      }
    },

    methods: {
      set_tab: function(name) {
        if (this.current_tab !== name) {
          this.$router.replace({
            name: 'core.price.type',
            params: { type: name }
          });
        }
      },

      get_name_tab(name) {
        return this.$t(`core.price.type.${name}`);
      }
    }
  };
</script>

<style lang="scss">
  section.d-flex {
    background: #fff;
    padding: 15px 15px;
  }

  .b-tabs {
    padding-right: 15px;

    &.w-20 {
      width: 190px;
    }

    .ivu-tabs-bar {
      border: none;
    }

    .ivu-tabs-nav-scroll {
      height: 140px;
    }

    .ivu-tabs-nav {
      float: none;

      .ivu-tabs-tab {
        display: block;

        &.ivu-tabs-tab-active,
        &.ivu-tabs-tab-focused {
          border-top: 1px solid #2196f3 !important;
          border-left: 1px solid #2196f3;
        }
      }
    }

    .ivu-tabs.ivu-tabs-card {
      &> .ivu-tabs-bar {
        .ivu-tabs-nav-container {
          height: 100%;
        }

        .ivu-tabs-tab {
          margin-bottom: 5px;
          border: 1px solid #dcdee2;
        }
      }
    }
  }
</style>
